import { normalize } from 'normalizr'
import { jsonPost } from 'api'
import { userSchema } from 'auth/schemas'

export const login = (email, password, remember, languageCode = 'EN') =>
    jsonPost(
        `${GRS_ACCOUNTS_SERVICE}/Login`,
        {
            UserId: email,
            IsRemember: remember,
            Password: password,
        },
        {
            'Accept-Language': languageCode,
        }
    )
        .then(response => normalize(response, userSchema))
        .catch(error => {
            throw new Error(error.message)
        })

export const getCurrentUser = () =>
    jsonPost(`${GRS_ACCOUNTS_SERVICE}/AuthenticateAccount`).then(response => {
        if (response && response.isLogin) return normalize(response, userSchema)
    })

export const logout = () => jsonPost(`${GRS_ACCOUNTS_SERVICE}/LogOutSession`)

export const checkUserExists = email =>
    jsonPost(`${GRS_ACCOUNTS_SERVICE}/CheckUserName`, {
        userId: email,
    }).catch(error => {
        throw new Error(error.message)
    })

export const createAccount = (
    firstName,
    lastName,
    email,
    password,
    nif = '',
    languageCode = 'EN',
    country = '',
    customerType = '',
    customerRegNr = '',
    businessName = '',
    phone = ''
) =>
    jsonPost(
        `${GRS_ACCOUNTS_SERVICE}/CreateAccount`,
        {
            LAZAccountDetail: {
                AccountCardDetail: [],
                EmailAddress: email,
                ISOLangCode: languageCode,
                Id: '-1',
                ParkingIndividualDetail: {
                    Address1: '',
                    Address2: '',
                    Billing_Address1: '',
                    Billing_Address2: '',
                    Billing_City: '',
                    Billing_Country: '',
                    Billing_FirstName: '',
                    Billing_LastName: '',
                    Billing_PostalCode: '',
                    Billing_State: '',
                    City: '',
                    Country: country,
                    EmailAddress: email,
                    FirstName: firstName,
                    Id: 0,
                    LastName: lastName,
                    Phone: phone,
                    PostalCode: '',
                    Salutation: '',
                    State: '',
                    VehicleDetail: [],
                    AccountCoupons: [],
                    Custom1: nif.toUpperCase(),
                    CustomerDocumentType: customerType,
                    CustomerDocumentNumber: customerRegNr,
                    BusinessName: businessName,
                },
                Password: password,
            },
        },
        {
            'Accept-Language': languageCode,
        }
    )
        .then(response => normalize(response, userSchema))
        .catch(error => {
            throw new Error(error.message)
        })

export const resetPassword = (email, languageCode = 'EN') =>
    jsonPost(
        `${GRS_ACCOUNTS_SERVICE}/ResetPassword`,
        {
            UserId: email,
            ISOLangCode: languageCode,
            eDataLocationId: '999014',
        },
        {
            'Accept-Language': languageCode,
        }
    ).catch(error => {
        throw new Error(error.message)
    })
